import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import UserForm from './UserForm'
import UserCard from './UserCard'

import Resource from '../../stores/resource'
const UserStore = Resource('users')

class NewUser extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    // Adjust attributes
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }
    // Remove display-only fields
    delete attributes.mobilePhone
    delete attributes.officePhone
    delete attributes.passwordConfirmation
    // Save!
    const fullName = `${attributes.firstName} ${attributes.lastName}`
    UserStore.create(attributes)
    .then((result) => {
      this.setState({
        saved: true,
        error: '',
        savedUser: result.data.data,
        snackbarMessage: `User "${fullName}" created!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedUser)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/users`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    const {
      user,
      saved,
      error,
      savedUser,
      snackbarMessage,
      redirect
    } = this.state

    if (redirect) return <Redirect push to={redirect}/>

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <UserForm
          formTitle={this.props.formTitle}
          code={user.code}
          name={user.name}
          phone={user.phone}
          address={user.address}
          city={user.city}
          province={user.province}
          country={user.country}
          postalCode={user.postalCode}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />
        <br/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create user">
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(saved)}
            title="User created">
            <p>
              A new user has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <UserCard
              user={savedUser}
              editCallback={() => this._redirectTo(`/users/${savedUser.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewUser



// WEBPACK FOOTER //
// ./src/components/Users/NewUser.jsx